import { PrismTheme } from 'prism-react-renderer'

const base: PrismTheme = {
  plain: { color: 'var(--color-bright)' },
  styles: [
    {
      types: ['punctuation', 'symbol', 'attr-name'],
      style: { color: 'var(--color-bright)' },
    },
    {
      types: [
        'variable',
        'keyword',
        'operator',
        'prolog',
        'constant',
        'builtin',
      ],
      style: { color: 'var(--color-accent)' },
    },
    {
      types: ['comment'],
      style: { color: 'var(--color-dim)' },
    },
    {
      types: ['null', 'class-name', 'boolean'],
      style: { color: '#55C2FF' },
    },
  ],
}

export const theme: PrismTheme = {
  ...base,
  styles: [
    ...base.styles,
    {
      types: ['string', 'char', 'tag', 'selector'],
      style: { color: 'var(--color-dim)' },
    },
    {
      types: ['inserted', 'function'],
      style: { color: 'var(--color-bright)' },
    },
  ],
}

export const terminalTheme: PrismTheme = {
  ...base,
  styles: [
    ...base.styles,
    {
      types: ['string'],
      style: { color: 'var(--color-dim)' },
    },
    {
      types: ['char', 'tag', 'selector'],
      style: { color: '#9568F5' },
    },
    {
      types: ['inserted', 'function', 'property'],
      style: { color: '#E47320' },
    },
    {
      types: ['function'],
      style: { color: 'var(--color-accent)' },
    },
    {
      types: ['property'],
      style: { color: 'var(--color-accent)' },
    },
  ],
}
